import React from "react";
import {Button, Col, Form, Modal} from "react-bootstrap";
import {GlobalContext} from "../../GlobalContext";
import Feedback from "react-bootstrap/Feedback";
import ChangePasswordForm from "./ChangePasswordForm";

export class ChangePasswordModal extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.show !== this.props.show) {
            this.setState({validated: false, errorMessage: '', form: {currentPassword: '',
                    newPassword1: '',
                    newPassword2: ''}});
        }
    }


    ok = () => {
    };



    render() {
        return <Modal size={this.props.size || "md"} show={this.props.show} onHide={this.props.onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Change My Password</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ChangePasswordForm onSuccess={this.props.onOk} onCancel={this.props.onCancel}/>
            </Modal.Body>
        </Modal>
    }
}